import { createContext, useContext, useRef, ReactNode } from "react"

import { RootStore, RootStoreModel } from "../RootStore"

const RootStoreContext = createContext<RootStore>({} as RootStore)

export const RootStoreProvider = ({ children }: { children: ReactNode }) => {
  const rootStore = useRef(RootStoreModel.create({}))

  return <RootStoreContext.Provider value={rootStore.current}>{children}</RootStoreContext.Provider>
}

export const useStores = () => useContext(RootStoreContext)
